/* eslint-disable */
export default {
  feedbackHeader: 'Enviar comentarios',
  back: 'Atrás',
  revert: 'Volver',
  instruction:
    'Sus comentarios tienen mucho valor para nosotros. Si tiene problemas al utilizar la aplicación, quiere solicitar una función o informar de un problema, estaremos encantados de ayudarle.',
  fillForm: 'Rellene el siguiente formulario y haga clic ',
  useMailBox:
    ' o utilice directamente su buzón de correo y envíe su solicitud a ',
  email: 'Su dirección de correo electrónico',
  reply: '(para que podamos contestarle)',
  emailPlaceHolder: 'ronald.app@ringcentral.com',
  feedbackTopic: 'Tema del comentario',
  topicPlaceHolder: 'Seleccione una opción',
  bugReport: 'Informe de errores',
  featureRequest: 'Solicitud de funciones',
  others: 'Otros',
  subject: 'Asunto',
  subjectPlaceHolder: 'Ayúdenos a saber cómo podemos ayudarle',
  description: 'Descripción detallada',
  descriptionPlaceHolder: 'Incluya la máxima información posible',
  send: 'Envíenos sus comentarios',
} as const;

// @key: @#@"feedbackHeader"@#@ @source: @#@"Submit Feedback"@#@
// @key: @#@"back"@#@ @source: @#@"Back"@#@
// @key: @#@"revert"@#@ @source: @#@"Revert"@#@
// @key: @#@"instruction"@#@ @source: @#@"Your feedback is valuable for us. If you have problems using the app, want to request a feature, or report a bug, we’re more than happy to help."@#@
// @key: @#@"fillForm"@#@ @source: @#@"Please fill in the form below and click "@#@
// @key: @#@"useMailBox"@#@ @source: @#@" or directly use your mailbox and send your request to "@#@
// @key: @#@"email"@#@ @source: @#@"Your email address"@#@
// @key: @#@"reply"@#@ @source: @#@"(so we can reply to you)"@#@
// @key: @#@"emailPlaceHolder"@#@ @source: @#@"ronald.app@ringcentral.com"@#@
// @key: @#@"feedbackTopic"@#@ @source: @#@"Feedback topic"@#@
// @key: @#@"topicPlaceHolder"@#@ @source: @#@"Please select an option"@#@
// @key: @#@"bugReport"@#@ @source: @#@"Bug report"@#@
// @key: @#@"featureRequest"@#@ @source: @#@"Feature request"@#@
// @key: @#@"others"@#@ @source: @#@"Others"@#@
// @key: @#@"subject"@#@ @source: @#@"Subject"@#@
// @key: @#@"subjectPlaceHolder"@#@ @source: @#@"Let us know how we can help you"@#@
// @key: @#@"description"@#@ @source: @#@"Full description"@#@
// @key: @#@"descriptionPlaceHolder"@#@ @source: @#@"Please include as much information as possible"@#@
// @key: @#@"send"@#@ @source: @#@"Send Your Feedback"@#@
